module.exports = __webpack_public_path__ + "img/desktop-5.4227b2dc.jpg";